module.exports = __webpack_public_path__ + "static/loto5-63ce32f2707d47bfabef338c73ddcd2a.svg";